<template>
  <div class="character" :style="{ backgroundImage: `url(${character.avatar || ''})`}">
    <div class="page-header">
      <i class="back-icon" @click.stop="$router.go(-1)"></i>
    </div>
    <div class="info" v-if="Object.keys(character).length">
      <div class="main">
        <p class="character-name">{{ character.name }}</p>
        <p class="character-desc">{{ character.description }}</p>
      </div>
      <TagList :list="character.tags" />
      <div class="btn" @click="handleChat">Chat</div>
    </div>
  </div>
</template>
<script>
import { getCharacterById } from '@/api';
import TagList from '@/components/TagList.vue';

export default {
  components: { TagList },
  data() {
    return {
      character: {},
      characterId: '',
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getCharacter();
    },
    async getCharacter() {
      const loading = this.$loading();
      const { params: { characterId: id } } = this.$route || {};
      if (!id) return;
      this.characterId = id;
      const res = await getCharacterById(id);
      if (res.code !== 0) return;
      this.character = res?.data?.character || {};
      loading.close();
    },
    handleChat() {
      this.$router.push(`/chatRoom/${this.characterId}`);
    },
  },
};
</script>
<style lang="less" scoped>
.character {
  height: 100vh;
  background-size: cover;
  background-position: center center;
  position: relative;
  display: flex;
  flex-direction: column;
  .page-header {
    display: flex;
    align-items: center;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    color: #fff;
    position: relative;
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back.png');
      });
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.3);
    z-index: 0;
  }
  .info {
    margin-top: auto;
    padding: 42px 16px;
    position: relative;
    .main {
      background: rgba(255, 255, 255, 0.5);
      padding: 0 10px;
      margin-bottom: 15px;
    }
    p {
      padding: 8px 0;
    }
    .character-name {
      font-size: 32px;
      font-weight: 600;
    }
    .character-desc {
      font-size: @fontSmall;
      line-height: 14px;
      padding-bottom: 16px;
    }
    .btn {
      background: linear-gradient(130.84deg, #3BDC7E 18.93%, #0DCFA9 79.21%);
      height: 54px;
      line-height: 54px;
      border-radius: 33px;
      text-align: center;
      font-size: @fontLarge;
      font-weight: 600;
      margin-top: 36px;
    }
  }
}
</style>
